import axios from 'axios';

const api = axios.create({
 // baseURL: "http://192.168.29.250:7003/api/"
   baseURL: "https://doctor-service.swasthyakhata.com/api/"
});

export default api;